const MindBodySeats = ({ classDetails, handleShow }) => {
  const seats     = classDetails.seats;
  const type      = classDetails.class.type_class;
  const coachImg  = classDetails.class.coach_image;
  const coachName = classDetails.class.coach_name;

  const getSeat = (num) => seats.find((s) => s.seat_number === num);

  const renderSeat = (num) => {
    const s = getSeat(num);
    if (!s) return null;
    return (
      <div
        key={s.id}
        className={`bola-seat mindbody-seat ${s.status === 1 ? 'ocupado' : ''}`}
        onClick={() => s.status !== 1 && handleShow(s.seat_number)}
      >
        <span>{s.seat_number}</span>
      </div>
    );
  };

  return (
    <div className="ride-grid-wrapper">
      <div className="mindbody-grid">
        {[1, 2, 3, 4, 5, 6, 7].map((num) => renderSeat(num))}

        {/* Coach — last column */}
        {coachImg ? (
          <div
            className="bola-coach mindbody-coach"
            style={{ backgroundImage: `url(${require(`../images/coaches/${coachImg}`)})` }}
          />
        ) : (
          <div className="bola-coach mindbody-coach">
            <span className="name-coach">{coachName || 'Coach'}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MindBodySeats;